<template>
  <div>
    <card title="Certification parameters">
      <div v-for="(certification_variable, index) in certification_variables_copies" v-bind:key="index" class="row">
        <div class="col-xl-12">
          <h5>{{ certification_variable.company.name }}</h5>
        </div>
        <div class="col-md-2">
          <fg-input
            type="number"
            label="resiliency"
            v-model="certification_variable.resiliency_certification_volume"
          ></fg-input>
        </div>
        <div class="col-md-2">
          <fg-input
            type="number"
            label="sustainability"
            v-model="certification_variable.sustainability_certification_volume"
          ></fg-input>
        </div>
        <div class="col-md-2">
          <fg-input
            type="number"
            label="suggestions"
            v-model="certification_variable.initiatives_and_engagement_volume"
          ></fg-input>
        </div>
        <div class="col-md-2">
          <fg-input
            type="number"
            label="consumption"
            v-model="certification_variable.consumption_certification_volume"
          ></fg-input>
        </div>
        <div class="col-md-2">
          <fg-input disabled="" type="number" label="sum" :value="getSum(certification_variable)"></fg-input>
        </div>
        <div class="col-md-1 mt-5">
          <p-button
            v-if="getSum(certification_variable) === 100"
            round
            icon
            outline
            type="success"
            @click.prevent.native="save(certification_variable)"
            v-tooltip="{
              content: 'Press for Save',
              placement: 'bottom-center',
              classes: ['info'],
            }"
          >
            <i class="fa fa-save" />
          </p-button>
          <p-button
            v-else
            round
            icon
            outline
            type="danger"
            v-tooltip="{
              content: 'Can not save if sum is not equal to 100',
              placement: 'bottom-center',
              classes: ['info'],
            }"
          >
            <i class="fa fa-times" />
          </p-button>
        </div>
        <div class="col-xl-12">
          <hr />
        </div>
      </div>
    </card>
  </div>
</template>

<script>
import CompanyCertificationVariablesController from '@/controllers/Certificates/CompanyCertificationVariablesController';

export default {
  name: 'CertificationParameters',
  props: {
    certification_variables: Array,
  },
  data() {
    return {
      certification_variables_copies: [],
    };
  },
  computed: {},
  mounted() {
    this.certification_variables_copies = this.certification_variables;
  },
  methods: {
    getSum(company_var) {
      return (
        parseInt(company_var.resiliency_certification_volume) +
        parseInt(company_var.sustainability_certification_volume) +
        parseInt(company_var.initiatives_and_engagement_volume) +
        parseInt(company_var.consumption_certification_volume)
      );
    },
    async save(certification_variable) {
      try {
        await CompanyCertificationVariablesController.update(certification_variable, certification_variable.id);
        this.$notify({
          type: 'success',
          title: 'Successfully saved!',
        });
      } catch (e) {
        Object.entries(error.response.data).forEach((item) => {
          this.$notify({
            type: 'danger',
            title: item[1],
          });
        });
      }
    },
  },
};
</script>

<style scoped></style>
